import { render } from "./Sidebar.vue?vue&type=template&id=44b4cb5a&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=44b4cb5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44b4cb5a"

export default script